import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "image"]

  connect() {
    // Show preview if input already has a file (from failed validation)
    if (this.hasInputTarget && this.inputTarget.files.length > 0) {
      this.preview()
    }
  }

  preview() {
    const file = this.inputTarget.files[0]

    if (file) {
      const reader = new FileReader()

      reader.onload = (e) => {
        this.imageTarget.src = e.target.result
        this.previewTarget.classList.remove('hidden')
      }

      reader.readAsDataURL(file)
    }
  }
}
